import React, { Component } from 'react'
import { Trans, withI18n, withI18nProps } from '@lingui/react'

import InfoIcon from 'client/shared/icons/info.svg'
import SVGInline from 'react-svg-inline'

import './unavailable-info.styl'
import { ResourceName } from 'client/shared/types/resource'

type Props = {
  withButtonInfo?: boolean
  kind?: ResourceName
} & withI18nProps

class _UnavailableInfo extends Component<Props> {
  static defaultProps = {
    withButtonInfo: false,
    kind: 'book',
  }

  render(): JSX.Element {
    const { withButtonInfo, kind, i18n } = this.props

    const resource = i18n._(`buttons.wishlist_${kind}`)
    let title = i18n._('buttons.wishlist_full_info', {
      resource,
    })
    if (withButtonInfo) {
      title = `${title} ${i18n._('buttons.wishlist_button_info')}`
    }
    const infoId = `buttons.wishlist_info_${kind}`

    return (
      <div className="unavailable-info">
        <SVGInline
          className="unavailable-info__icon"
          svg={InfoIcon}
          title={title}
          data-tooltip
        />
        <span className="unavailable-info__text">
          <Trans id={infoId} />
        </span>
      </div>
    )
  }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const UnavailableInfo = withI18n({ update: true })(_UnavailableInfo)
